var map = {
	"./tool-card.svg": "0425",
	"./tool-circle.svg": "0303",
	"./tool-data-base.svg": "1e57",
	"./tool-diamond.svg": "7ea1",
	"./tool-doc.svg": "4d09",
	"./tool-ellipse.svg": "fc2e",
	"./tool-graffiti.svg": "6bff",
	"./tool-list.svg": "1d44",
	"./tool-parallelogram-right.svg": "3041",
	"./tool-parallelogram.svg": "cf01",
	"./tool-square.svg": "af9a",
	"./tool-star.svg": "b971",
	"./tool-trapezoid.svg": "eb53",
	"./tool-triangle-bottom.svg": "1f29",
	"./tool-triangle-left.svg": "f86a",
	"./tool-triangle-right.svg": "5140",
	"./tool-triangle-top.svg": "d8f1",
	"./tool-upload.svg": "1a68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db72";